import { Component, Input } from '@angular/core';
import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'app-shared-popup',
  standalone: true,
  imports: [DialogModule],
  templateUrl: './shared-popup.component.html',
  styleUrl: './shared-popup.component.scss'
})
export class SharedPopupComponent {
  @Input() header: string = '';
  display: boolean = false;

  // Method to show the dialog
  showDialog() {
    this.display = true;
  }

  // Method to hide the dialog
  hideDialog() {
    this.display = false;
  }
}
